/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

// ─── Coverage filter shared types & constants ────────────────────────────────

/**
 * Visual status for a product tile's coverage pill.
 */
export type CoverageStatus = 'available' | 'short' | 'searching';

/**
 * Fetch lifecycle status for the bulk availability call.
 */
export type AvailabilityFetchStatus = 'idle' | 'loading' | 'success' | 'error';

/** Lifecycle status for the full filtered-set builder. */
export type FilteredSetStatus = 'inactive' | 'building' | 'ready' | 'error';

/** URL path tokens that identify a Finished Products category page. */
export const FINISHED_PRODUCTS_URL_TOKENS = ['finished-products', 'produits-finis'];

/** Query-string parameter name for persisting the coverage target. */
export const COVERAGE_PARAM = 'coverage';

/** Step increment/decrement for the coverage stepper. */
export const COVERAGE_STEP = 50;

/** Number of products fetched per SearchByCriteria cursor call. */
export const FILTERED_CHUNK_SIZE = 800;

/** Default page size when module config omits itemsPerPage. */
export const FILTERED_PAGE_SIZE_FALLBACK = 24;
